import type { Position } from '@/types/generated/common/trading'

// Composite row identity shared by selection/context-menu/group state and the
// per-row position lookup atoms — a bare symbol isn't unique across accounts/venues.
export function getPositionRowKey(
  accountId: Position['accountId'],
  exchange: Position['exchange'],
  symbol: Position['symbol']
) {
  return `${accountId}-${exchange}-${symbol}`
}

// Never a real accountId-exchange-symbol combo — used to route a consumer's
// currently-unneeded `positionByRowKeyAtomFamily` lookup to one shared,
// always-null atomFamily entry instead of a live key.
export const POSITION_LOOKUP_SENTINEL = '__position_row_unused__'
